import React, { useEffect , useState } from "react";
import Top from "../../Top";
import Left from "../../Left";
import { useNavigate } from "react-router-dom";
import { Button, Grid } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

import CheckIcon from "@mui/icons-material/Check";

// For Calendar
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { makePostRequest ,makeGetRequest} from "../../../utils/utils";
import swal from "sweetalert";
import dayjs from "dayjs";

import { Formik, Form } from "formik";
import * as Yup from "yup";

// End

const steps = ["Details", "Review", "Confirm"];

function BookAmenityNew() {
  const navigate = useNavigate();

  const showBooked = () => {
    var element = document.getElementById("showBookedID");
    element.classList.toggle("showCalendarSt");
  };

  // For Calendar
  const [, onChange] = useState(new Date());
  // End

  // const [chkedval, setchkedval] = React.useState(true);
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const [count,setCount]=React.useState(0);
  const [activeIndex,setActiveIndex]=React.useState();
  const isStepOptional = (step) => {
    return step === 1;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    
    if(count===1)
    {
        bookAmenity();
    }
    setCount(count+1);
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

   const disabledDates = [
    new Date(2023, 6, 15),
    new Date(2023, 6, 23),
  ];

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <>
            <div className="stepperInnrMain">
              <div className="bookAmeContDiv">
                <div className="headOfAmenity">
                  <h1>Book Amenity</h1>{" "}
                  <span onClick={showBooked}> 
                    <CalendarMonthIcon /> Show Booking
                  </span>
                </div>

                <div className="showCalendarMain" id="showBookedID">
                  <div className="availookedMain">
                    <div>
                      <span className="availableSt"></span>Available
                    </div>
                    <div>
                      <span className="bookedSt"></span>Booked
                    </div>
                  </div>
                  <div>
                    <Calendar onChange={onChange}  maxDetail="month"
          minDetail="month" tileDisabled={({date, view}) =>
          (view === 'month') && // Block day tiles only
          disabledDates.some(disabledDate =>
            (date.getFullYear() === disabledDate.getFullYear() &&
            date.getMonth() === disabledDate.getMonth() &&
            date.getDate() === disabledDate.getDate()) 
          )} />
                  </div>
                </div>
                

                <div className="dateTimeMain">
                  <label className="labSt">Select Date</label>
               
                  <div className="inpNLine">
                    <input type="date" className="inputSt" value={sel_bookingDate} onChange={(e)=>handleSelectedDate(e)}/>
                    <p>Limited 3 times per week by the user</p>
                  </div>
                </div>

                <div className="seleTimSloMain">
                  <label
                    className="labSt"
                    style={{ width: "100%", float: "left" }}
                  >
                    Select Date
                  </label>
                  {(accessibility==='Hourly')?
                  <>
                  {lstAvailableTime.map((option,index)=>(
                    <>
                  <Button key={index} 
                  className={
                    index === activeIndex
                      ? "timeSlotButton timeSlotButtonGreen"
                      : "timeSlotButton timeSlotButtonGrey"
                  }
                 onClick={()=>handleSelectedTime(option,lstAvailableTime[index+1],index)}>
                    {dayjs(option).format('hh:mm a')} to {dayjs(lstAvailableTime[index+1]).format('hh:mm a')}
                  </Button></>
                  ))}
                  
                  </>:
                  (accessibility==='Half Day')?
                  <>
                  <Button 
                  className={
                    activeIndex===0
                      ? "timeSlotButton timeSlotButtonGreen"
                      : "timeSlotButton timeSlotButtonGrey"
                  }
                 onClick={()=>handleSelectedTime(lstAvailableTime[0],lstAvailableTime[1],0)}>
                    {dayjs(lstAvailableTime[0]).format('hh:mm a')} to {dayjs(lstAvailableTime[1]).format('hh:mm a')}
                  </Button>
                  </>:
                  (accessibility==='Full Day')?
                  <>
                  <Button 
                  className={
                    activeIndex===1
                      ? "timeSlotButton timeSlotButtonGreen"
                      : "timeSlotButton timeSlotButtonGrey"
                  }
                 onClick={()=>handleSelectedTime(lstAvailableTime[2],lstAvailableTime[3],1)}>
                    {dayjs(lstAvailableTime[2]).format('hh:mm a')} to {dayjs(lstAvailableTime[3]).format('hh:mm a')}
                  </Button>
                  </>
                  :<></>
                  }

                  {/* <Button className="timeSlotButton timeSlotButtonYellow">
                    8:00am to 9:00am
                  </Button>
                  <Button className="timeSlotButton timeSlotButtonYellow">
                    8:00am to 9:00am
                  </Button>
                  <Button className="timeSlotButton">8:00am to 9:00am</Button>
                  <Button className="timeSlotButton timeSlotButtonGrey">
                    8:00am to 9:00am
                  </Button>
                  <Button className="timeSlotButton">8:00am to 9:00am</Button>
                  <Button className="timeSlotButton">8:00am to 9:00am</Button> */}
                </div>

                <Formik
          enableReinitialize
          initialValues={formikInitials}
          validationSchema={Validation_Schema}
        // onSubmit={(e)=>addNoticeBoard(e)}
        >
          {({
            values,
            handleChange,
            errors,
            setFieldTouched,
            touched,
            isValid,
            handleSubmit,
          }) => (
            <Form>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <label className="labSt">Number of People</label>
                    <input type="text" className="inputSt" value={values.booked_forNoOfPeople}
                              onChange={handleChange("booked_forNoOfPeople")}
                              onBlur={() => setFieldTouched("booked_forNoOfPeople")}
                              onChangeCapture={(e) =>
                                setBookedForNoOfPeople(e.target.value)
                              }
                            />
                            {errors.booked_forNoOfPeople && touched.booked_forNoOfPeople ? (
                              <div
                                style={{ color: "red" }}
                                className="errorField"
                              >
                                {errors.booked_forNoOfPeople}
                                </div>
                            ) : null}
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <label className="labSt">On behalf of</label>
                    <input type="text" className="inputSt" value={values.onBehalfOf}
                              onChange={handleChange("onBehalfOf")}
                              onBlur={() => setFieldTouched("onBehalfOf")}
                              onChangeCapture={(e) =>
                                setOnBehalfOf(e.target.value)
                              }
                            />
                            {errors.onBehalfOf && touched.onBehalfOf ? (
                              <div
                                style={{ color: "red" }}
                                className="errorField"
                              >
                                {errors.onBehalfOf}
                                </div>
                            ) : null}
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <label className="labSt">Event description / Notes</label>
                    <textarea
                      className="textAriaSt"
                      placeholder="Type here"
                      value={values.description}
                      onChange={handleChange("description")}
                      onBlur={() => setFieldTouched("description")}
                      onChangeCapture={(e) =>
                        setDescription(e.target.value)
                      }
                    />
                    {errors.description && touched.description ? (
                      <div
                        style={{ color: "red" }}
                        className="errorField"
                      >
                        {errors.description}
                        </div>
                    ) : null}
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <FormControlLabel
                      control={<Checkbox  value={values.isEmailSend}/>}
                      label="Send an email reminder"
                    />
                  </Grid>
                </Grid>
                </Form>
          )}
        </Formik>
              </div>
            </div>
          </>
        );

      case 1:
        return (
          <>
            <div className="stepperInnrMain">
              <div className="priceTbMain">
                <table>
                  <tr>
                    <td>Amenity </td>
                    <td style={{ fontWeight: 500 }}>Swimming pool</td>
                  </tr>
                  <tr>
                    <td>Booking date</td>
                    <td style={{ fontWeight: 500 }}>23/3 2023</td>
                  </tr>
                  <tr>
                    <td>Booking time</td>
                    <td style={{ fontWeight: 500 }}>8:00 am to 9:00 am</td>
                  </tr>
                  <tr>
                    <td>---</td>
                    <td style={{ fontWeight: 500 }}>9:00 am to 10:00 am</td>
                  </tr>
                  <tr>
                    <td>Description / Note</td>
                    <td style={{ fontWeight: 500 }}>---</td>
                  </tr>
                </table>
              </div>
            </div>
          </>
        );
      case 2:
        return (
          <>
            <div className="stepperInnrMain">
              <div className="succBookingDiv">
                <CheckIcon /> Your booking has been confirmed
              </div>
              <div className="headOfAmenity">
                <h1>Booking Confirmed</h1>
              </div>
              <div className="priceTbMain">
                <table>
                  <tr>
                    <td>Booking Number </td>
                    <td style={{ fontWeight: 500 }}>87595435</td>
                  </tr>
                  <tr>
                    <td>Amenity </td>
                    <td style={{ fontWeight: 500 }}>Swimming pool</td>
                  </tr>
                  <tr>
                    <td>Booked by </td>
                    <td style={{ fontWeight: 500 }}>
                      Prakash jha , A wing 208
                    </td>
                  </tr>
                  <tr>
                    <td>Phone </td>
                    <td style={{ fontWeight: 500 }}>+91 9823898485</td>
                  </tr>
                  <tr>
                    <td>Email reminder </td>
                    <td style={{ fontWeight: 500 }}>No, Thanks</td>
                  </tr>
                  <tr>
                    <td>Booking date </td>
                    <td style={{ fontWeight: 500 }}>23/3 2023</td>
                  </tr>
                  <tr>
                    <td>Booking time </td>
                    <td style={{ fontWeight: 500 }}>8:00 am to 9:00 am</td>
                  </tr>
                  <tr>
                    <td>--- </td>
                    <td style={{ fontWeight: 500 }}>9:00 am to 10:00 am</td>
                  </tr>
                  <tr>
                    <td>Administrator approval status </td>
                    <td style={{ fontWeight: 500 }}>Approved</td>
                  </tr>
                  <tr>
                    <td>Payment status </td>
                    <td style={{ fontWeight: 500 }} className="notPaidRed">
                      Not paid
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </>
        );
      case 3:
        return (
          <>
            <div className="stepperInnrMain">kkk</div>
          </>
        );
      default:
        return "unknown step";
    }
  }

  const Validation_Schema = Yup.object().shape({
    booked_forNoOfPeople: Yup.string()
    .matches(
      /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
      "Invalid Input"
    )
    .min(1, "Invalid Input")
    .max(4,"Invalid Input")
    .required("Required"),
    onBehalfOf: Yup.string().required("Required"),
    description: Yup.string().required("Required"),

  });

  var formikInitials={
    booked_forNoOfPeople:0,
    onBehalfOf:'',
    description:'',
    isEmailSend:true
  };
  
    const [selectedDate, setSelectedDate] = React.useState();
    const [amenitiesList, setAmenitiesList] = React.useState([]);
    const[selectedAmenityName,setSelectedAmenityName]=React.useState();
    const[selectedAmenityId,setSelectedAmenityId]=React.useState();
    const[selectedAmenityImg,setSelectedAmenityImg]=React.useState();
    const[sel_bookingDate,setSel_bookingDate]=React.useState();
    const [lstAvailableDays,setLstAvailableDays]=React.useState([]);
    const [lstAvailableTime,setLstAvailableTime]=React.useState([]);
   
    const [selectedTimeJson,setSelectedTimeJson]=React.useState({date:'',start_time:'',end_time:''});
    const [booked_forNoOfPeople,setBookedForNoOfPeople]=React.useState();
    const [onBehalfOf,setOnBehalfOf]=React.useState();
    const [description,setDescription]=React.useState();
    const [isEmailSend]=React.useState(true);
    const [amenityBookings,setAmenityBookings]=React.useState([]);
    const [amenityFee,setAmenityFee]=React.useState();
    const [cancellationFee,setCancellationFee]=React.useState();
    const [amenityCapecity,setAmenityCapecity]=React.useState();
    const [bookingCapecity,setBookingCapecity]=React.useState();
    const [,setBookingCount]=React.useState();
    const [startTime,setStartTime]=React.useState();
    const [endTime,setEndTime]=React.useState();
    const [accessibility,setAccessibility]=React.useState();
    const [,setIsAmenityBooked]=React.useState(false);
    const [bookedAmenityTime,setBookedAmenityTime]=React.useState([]);


    async function handleSelectedTime(startime,endtime,selectedIndex){
        selectedTimeJson.date=selectedDate;
        selectedTimeJson.start_time=startime;
        selectedTimeJson.end_time=endtime;
        setSelectedTimeJson(selectedTimeJson);
        setActiveIndex(selectedIndex);
    }


  async function AmenitiesListing() {
      let bodyFormData = {
        status: true,
      };
  
      makePostRequest("amenities/alllisting", bodyFormData)
        .then((response) => {
          if (response.status === 201) {
            const data = response.data.data.rows;
            console.log('Amenities List',data);
            setAmenitiesList(data);
          } else {
            swal("There was an error!", response.message, "warning");
          }
        })
        .catch((err) => {
          swal("There was an error!", "more error details", "warning");
        });
    }
    
  async function handleSelectedDate(e)
  {
     let selectedDate=e.target.value;

     console.log('Bookings :',amenityBookings);
     for(let i=0;i<amenityBookings.length;i++)
     {  
       if(selectedDate==amenityBookings[i].bookings.date)
       {
          console.log('Allready BOoked ',amenityBookings[i].bookings.date);
          setIsAmenityBooked(true);
          
          if(accessibility=='Full Day')
            swal("Amenity Allready Booked !", "Please select other date", "warning");
          else
          {
              bookedAmenityTime.push({startTime:amenityBookings[i].bookings.start_time,endTime:amenityBookings[i].bookings.end_time}
                )
          }
        }
     }
     setBookedAmenityTime(bookedAmenityTime)
     setSelectedDate(selectedDate);
   
      console.log('Selected Booking Date ',new Date(selectedDate).getDay())
      setSel_bookingDate(e.target.value);
      let selectedDay=new Date(selectedDate).getDay();

      let dayObj=JSON.parse(JSON.stringify(lstAvailableDays[selectedDay-1]))

      if(accessibility=='Half Day')
      {
        let firstHalfStartTime=new Date(dayObj.start_time).getTime();    
        let firstHalfEndTime=new Date(dayObj.end_time).getTime();
        let secondHalfStartTime=new Date(dayObj.second_half_start_time).getTime();    
        let secondHalfEndTime=new Date(dayObj.second_half_end_time).getTime();
        lstAvailableTime.push(firstHalfStartTime);
        lstAvailableTime.push(firstHalfEndTime);
        lstAvailableTime.push(secondHalfStartTime);
        lstAvailableTime.push(secondHalfEndTime);
      }
      else if(accessibility=='Hourly')
      {
        let startTime=new Date(dayObj.start_time).getTime();    
        let endTime=new Date(dayObj.end_time).getTime();
        // let addedTime;
        while(startTime<endTime)
        {
          startTime =startTime+3600000;
          console.log('AddedTime ',dayjs(startTime).format('hh:mm a'));

         lstAvailableTime.push(startTime);
        }
      }
      else if(accessibility=='Full Day')
      {
        let startTime=new Date(dayObj.start_time).getTime();    
        let endTime=new Date(dayObj.end_time).getTime();
        lstAvailableTime.push(startTime);
        lstAvailableTime.push(endTime);
      }
     
      setLstAvailableTime(lstAvailableTime);

      for(let j=0;j<bookedAmenityTime.length;j++)
      {
        if(lstAvailableTime.includes(bookedAmenityTime[j].startTime))
          console.log("Booked Time")
        else
          console.log("Not Booked ")
      }
           
  }

  async function bookAmenity()
  {
    let inputData={
      'amenity_id':selectedAmenityId,
      'resident_id':onBehalfOf,
      'bookings':selectedTimeJson,
      'capacity':booked_forNoOfPeople,
      'description':description,
      'email_reminder':isEmailSend,
      'status':'pending'
      // 'is_paid':,
      // 'advance_amt':,
      // 'paid_amt':,
      // 'status':,
      // 'cancel_reason':,
    }

    makePostRequest("amenities/bookAmenity", inputData)
    .then((response) => {
      if (response.data.status === "1") {
        swal("Success", "Amenity Booked successfully", "success", {
          timer: 1000,
          buttons: false,
        });
        navigate("/Amenities");
      }
    })
    .catch((err) => {
      swal("There was an error!", "more error details", "warning");
      console.log("Something went wrong!!", err);
    });

      console.log('Booked Amenity Data ',inputData);
  }

  async function getBookedAmenities()
  {
    makeGetRequest("amenities/bookAmenity/")
    .then((response) => {
      if (response.data.status === "1") {
        swal("Success", "Amenity Booked successfully", "success", {
          timer: 1000,
          buttons: false,
        });
        navigate("/Amenities");
      }
    })
    .catch((err) => {
      swal("There was an error!", "more error details", "warning");
      console.log("Something went wrong!!", err);
    });
  }

  async function getAllBookings(amenityId)
  {
    makeGetRequest("amenities/getAllbooking/"+amenityId)
    .then((response) => {
      if (response.data.status === "1") {
        console.log('Booked Amenity : ',response.data);
        setAmenityBookings(response.data.data)
       
      }
    })
    .catch((err) => {
      swal("There was an error!", "more error details", "warning");
      console.log("Something went wrong!!", err);
    });
  }
  
   useEffect(()=>{
    console.log(localStorage.getItem('amenityObj'));
    let data=JSON.parse(localStorage.getItem('amenityObj'));
    setSelectedAmenityName(data.amenity_name);

    setSelectedAmenityId(data.amenity_id);
    console.log(data.lstAmenityImages[0]);
    setSelectedAmenityImg(data.lstAmenityImages[0]);
    console.log(data.available_days);
    setLstAvailableDays(data.available_days)
    setAccessibility(data.accessibility);

    setAmenityFee(data.charges);
    setCancellationFee(data.cancellation_charges);
    setAmenityCapecity(data.amenity_capacity);
    setBookingCapecity(data.booking_capacity);
    setBookingCount(data.bookingCount);

    let selectedDay=new Date().getDay();

    let dayObj=JSON.parse(JSON.stringify(data.available_days[selectedDay-1]))

      let startTime=dayjs(dayObj.start_time).format('hh:mm a') ;
      let endTime=dayjs(dayObj.end_time).format('hh:mm a') ;
      setStartTime(startTime);
      setEndTime(endTime);

    getAllBookings(data.amenity_id);
    AmenitiesListing();

  },[])

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Book Amenity</h1>
          </Grid>

          <Grid item xs={12} md={12}>
            <div className="booksBtnsMain">
              {amenitiesList.map((option)=>(
              <Button key={option.amenity_id}   className={
                option.amenity_id === selectedAmenityId
                  ? "booksBt booksBtActive"
                  : "booksBt"
              } >{option.amenity_name}</Button>
              ))}
                       
            </div>
          </Grid>

          <Grid item xs={12} md={12}>
            <div className="bookAmMainNew bookAmMainNewPageMain">
              <div className="">
                <div className="bookAmiListNewInner">
                  <div className="bookAminiDetailsMain">
                    <div className="ameniDetailView">
                      <div className="amenitOverlay">{selectedAmenityName}</div>
                      <img src={selectedAmenityImg} />
                    </div>
                  </div>
                </div>
              </div>

              <Grid container spacing={3}>
                <Grid item xs={12} md={8}>
                  <div className="amenityStepperMain amenityStepperMainForLine">
                    <div className="stepMaindi">
                      <Box sx={{ width: "100%" }}>
                        <Stepper activeStep={activeStep}>
                          {steps.map((label, index) => {
                            const stepProps = {};
                            const labelProps = {};
                            if (isStepOptional(index)) {
                              labelProps.optional = (
                                <Typography variant="caption"></Typography>
                              );
                            }
                            if (isStepSkipped(index)) {
                              stepProps.completed = false;
                            }
                            return (
                              <Step key={label} {...stepProps}>
                                <StepLabel {...labelProps}>{label}</StepLabel>
                              </Step>
                            );
                          })}
                        </Stepper>
                        {activeStep === steps.length ? (
                          <React.Fragment>
                            <Typography sx={{ mt: 2, mb: 1 }}>
                              <div className="stepperInnrMain">
                                <div className="successDiv">
                                  <img src="https://i.pinimg.com/originals/0d/cd/6f/0dcd6f4e410a34465a2d611913199e50.gif" />
                                  <h4>
                                    Your booking has been
                                    <br /> confirmed
                                  </h4>
                                </div>
                              </div>
                            </Typography>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                pt: 2,
                              }}
                            >
                              <Box sx={{ flex: "1 1 auto" }} />
                              <div className="resetBOuter">
                                <Button
                                  onClick={handleReset}
                                  className="primaryBtn"
                                >
                                  Create New
                                </Button>
                              </div>
                            </Box>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            {/* <Typography sx={{ mt: 2, mb: 1 }}>Step {activeStep + 1}</Typography> */}
                            <form>{getStepContent(activeStep)}</form>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                pt: 2,
                              }}
                            >
                              <Button
                                color="inherit"
                                disabled={activeStep === 0}
                                onClick={handleBack}
                                sx={{ mr: 1 }}
                              >
                                Back
                              </Button>
                              <Box sx={{ flex: "1 1 auto" }} />
                              {isStepOptional(activeStep) && (
                                <Button
                                  color="inherit"
                                  onClick={handleSkip}
                                  sx={{ mr: 1 }}
                                >
                                  {/* Skip */}
                                </Button>
                              )}

                              <Button
                                onClick={handleNext}
                                className="primaryBtn"
                              >
                                {activeStep === steps.length - 1
                                  ? "Pay and save your booking"
                                  : "Next"}
                              </Button>
                            </Box>
                          </React.Fragment>
                        )}
                      </Box>
                    </div>
           
                  </div>
                </Grid>
                <Grid item xs={12} md={4}>
                  <div>
                    <div className="headOfAmenity">
                      <h1>Details and pricing deposit structure</h1>
                    </div>
                    <div className="amDetlsMain">
                      <p>
                        <span>Amenity Fee</span>
                        <b>{amenityFee}</b>
                        {}
                      </p>
                      <p>
                        <span>Cancellation fee</span>
                        <b>{cancellationFee}</b>
                      </p>
                      <p>
                        <span>Amenity capacity</span>
                        <b>{amenityCapecity} People</b>
                      </p>
                      <p>
                        <span>Booking capacity</span>
                        <b>{bookingCapecity} People</b>
                      </p>
                      <p>
                        <span>Booking Count</span>
                        <b>Multiple</b>
                      </p>
                    </div>

                    <div className="headOfAmenity">
                      <h1>Hours of Operations</h1>
                    </div>
                    <div className="amDetlsMain">
                      <p>
                        <span>Open from</span>
                        <b>{startTime}</b>
                      </p>
                      <p>
                        <span>Open till</span>
                        <b>{endTime}</b>
                      </p>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default BookAmenityNew;
